import {
  HbrDatePicker,
  HbrIcon,
  HbrInput,
} from '@harbor/elements-react-standalone';
import React from 'react';
import StbButton from '../../security-toolbox-ui/StbButton';
import { trash } from '@harbor/elements/icons';


type FilterValue = number | string | string[];

interface Props {
  filterValue: FilterValue;
  filterIndex: number;
  operatorType: string;
  handleFilterComparisonChange: (
    filterIndex: number,
    value: FilterValue
  ) => void;
}

const StbTableFilterValueControl = ({
  operatorType,
  handleFilterComparisonChange,
  filterIndex,
  filterValue,
}: Props) => {
  const addComparisonListItem = () => {
    handleFilterComparisonChange(filterIndex, [
      ...(filterValue as string[]),
      '',
    ]);
  };

  const removeComparisonListItem = (itemIndex: number) => {
    if ((filterValue as string[]).length > 1) {
      (filterValue as string[]).splice(itemIndex, 1);
      handleFilterComparisonChange(filterIndex, filterValue);
    }
  };

  // Waiting on api implementation
  // this was using the whole set of data so could get all available values given a column name
  // we'll be paginating on the server, so we'll need an extra endpoint
  // for returning search term results so that we can provide selectable values for large sets of results
  // fallback: use text inputs instead of search-selects for now
  switch (operatorType) {
    case 'number':
      return (
        <HbrInput
          type='number'
          value={filterValue == null ? '' : String(filterValue)}
          onHbr-change={(e) =>
            handleFilterComparisonChange(filterIndex, parseInt(e.target.value))
          }
        />
      );
    case 'select':
      /**
       * Using input for now. 
       * select requires an api endpoint to search on values for the given column.
       */
    // Intentional fallthrough to 'text' case
    // eslint-disable-next-line no-fallthrough
    case 'text':
      return (
        <HbrInput
          type='text'
          value={filterValue as string}
          onHbr-change={(e) =>
            handleFilterComparisonChange(filterIndex, e.target.value)
          }
        />
      );
    case 'date':
      return (
        <div className="flex justify-stretch">
        <HbrDatePicker
          value={filterValue == null ? '' : String(filterValue)}
          onHbr-change={(e) => handleFilterComparisonChange(filterIndex, e.target.value)}
        />
        </div>
      );
    case 'multi':
      return (
        <div className="flex flex-col">
          {((filterValue as string[]) ?? []).map((term: string, n: number) => (
            <div
              className='flex items-center mb-1 gap-1'
              key={`filter-comparison-${n}-${term}`}
            >
              <HbrInput
                size='small'
                className='flex-1'
                type='text'
                value={term}
                onHbr-change={(e) =>
                  handleFilterComparisonChange(filterIndex, [
                    ...(filterValue as string[]).slice(0, n),
                    e.target.value,
                    ...(filterValue as string[]).slice(n + 1),
                  ])
                }
              >
                <HbrIcon
                  slot='suffix'
                  asset={trash}
                  name='trash'
                  className='cursor-pointer hover:text-danger'
                  onClick={() => removeComparisonListItem(n)}
                />
              </HbrInput>
            </div>
          ))}
          <StbButton className="self-end" size='xsmall' role='add' variant="text" onClick={addComparisonListItem}>
            Add list item
          </StbButton>
        </div>
      );
    default:
      return <></>;
  }
};

export default StbTableFilterValueControl;
